import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "./SessionContext";
import { StatePanel } from "@/components/StatePanel";
import { useLocale } from "@/locale/LocaleContext";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, loading } = useSession();
  const location = useLocation();
  const { m } = useLocale();

  if (loading) {
    return <StatePanel kind="pending" title={m.common.loading} />;
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}

export function RequireOperator({ children }: { children: ReactNode }) {
  const { session, isOperator, loading } = useSession();
  const { m } = useLocale();

  if (loading) {
    return <StatePanel kind="pending" title={m.common.loading} />;
  }

  if (!session) {
    return (
      <StatePanel
        kind="unauthenticated"
        title={m.states.sessionEnded}
        message={m.states.sessionEndedBody}
        actionLabel={m.common.signIn}
        onAction={() => {
          window.location.href = "/login";
        }}
      />
    );
  }

  if (!isOperator) {
    return (
      <StatePanel
        kind="forbidden"
        title={m.states.forbidden}
        message={m.states.forbiddenBody}
        actionLabel={m.nav.cabinet}
        onAction={() => {
          window.location.href = "/app";
        }}
      />
    );
  }

  return children;
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { session, isAdmin, loading } = useSession();
  const { m } = useLocale();

  if (loading) {
    return <StatePanel kind="pending" title={m.common.loading} />;
  }

  if (!session) {
    return (
      <StatePanel
        kind="unauthenticated"
        title={m.states.sessionEnded}
        message={m.states.sessionEndedBody}
        actionLabel={m.common.signIn}
        onAction={() => {
          window.location.href = "/login";
        }}
      />
    );
  }

  if (!isAdmin) {
    return (
      <StatePanel
        kind="forbidden"
        title={m.states.forbidden}
        message={m.states.forbiddenBody}
        actionLabel={m.nav.cabinet}
        onAction={() => {
          window.location.href = "/app";
        }}
      />
    );
  }

  return children;
}
